
import Vue from "vue"
import App from './app.vue'
import apolloProvider from './storefront'
import store from './store'
// import VueDraggable from 'vue-draggable'
// import 'vue-draggable/polyfills'

const appSelector = document.getElementById("personalize-vue")


if(appSelector) {

  new Vue({
    el: appSelector,
    store,
    provide: apolloProvider.provide(),
    render: h => h(App)
  })

  // Vue.use(VueDraggable)
}



// WEBPACK FOOTER //
// ../assets/js/personalize/index.js